import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import resolveRouteAccess from '@/lib/routes/resolveRouteAccess.js';
import { hasFinishedOnboarding } from '@/redux/selectors/sessionSelectors.js';
import { authSessionStatus, sessionContextStatus } from '@/redux/selectors/userSelectors.js';
import BootScreen from '@/components/surfaces/BootScreen.jsx';
import AccountLoadError from '@/components/surfaces/AccountLoadError.jsx';

/** Shows its screen only to the people `access` allows (see routes.js); everyone else is sent where they belong. */
const RouteGate = ({ access, children }) => {
  const location = useLocation();
  const decision = resolveRouteAccess({
    access,
    sessionStatus: useSelector(authSessionStatus),
    contextStatus: useSelector(sessionContextStatus),
    hasFinishedOnboarding: useSelector(hasFinishedOnboarding),
    returnTo: `${location.pathname}${location.search}`,
    next: new URLSearchParams(location.search).get('next') || ''
  });

  if (decision.kind === 'boot') {
    return <BootScreen />;
  }

  if (decision.kind === 'error') {
    return <AccountLoadError />;
  }

  if (decision.kind === 'redirect') {
    return <Navigate to={decision.to} replace />;
  }

  return children;
};

export default RouteGate;
